import {
  PaymentGatewayAdapter,
  RazorpayOptions,
  RazorpayPaymentGatewayRequest,
  RazorpayPaymentGatewayResult,
} from "./razorpayType";

let scriptPromise: Promise<void> | null = null;

function loadRazorpayScript(): Promise<void> {
  if (scriptPromise) return scriptPromise;

  scriptPromise = new Promise<void>((resolve, reject) => {
    if (typeof window === "undefined") {
      return reject(new Error("Razorpay can only be loaded in browser"));
    }

    // already present
    if ((window as any).Razorpay) {
      return resolve();
    }

    // const script = document.createElement("script");
    // script.src = "add script url", //"https://checkout.razorpay.com/v1/checkout.js";
    // script.async = true;
    // script.onload = () => resolve();
    // script.onerror = () =>
    //   reject(new Error("Failed to load Razorpay checkout script"));
    // document.body.appendChild(script);
  });

  return scriptPromise;
}

export const razorpayGateway: PaymentGatewayAdapter = {
  async openPayment(
    req: RazorpayPaymentGatewayRequest,
  ): Promise<RazorpayPaymentGatewayResult> {
    try {
      await loadRazorpayScript();
    } catch (e: any) {
      return {
        status: "failed",
        errorMessage: e?.message || "Unable to load payment gateway",
      };
    }

    if (!process.env.REACT_APP_RAZORPAY_KEY_ID) {
      console.warn("Razorpay key missing");
      return {
        status: "failed",
        errorMessage: "Payment gateway not configured",
      };
    }

    return new Promise<RazorpayPaymentGatewayResult>((resolve) => {
      const options: RazorpayOptions = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID!,
        amount: req.amountPaise,
        currency: req.currency,
        order_id: req.orderId,
        name: "Your App Name",
        description: "Bill Payment",
        handler: (response) => {
          resolve({
            status: "success",
            success: {
              paymentId: response.razorpay_payment_id,
              orderId: response.razorpay_order_id,
              signature: response.razorpay_signature,
            },
          });
        },
        modal: {
          ondismiss: () => {
            resolve({ status: "cancelled" });
          },
        },
        prefill: {
          name: req.customerName,
          contact: req.customerMobile,
          email: req.customerEmail,
        },
        notes: req.notes,
        theme: { color: "#2563EB" },
      };

      const rzp = new (window as any).Razorpay(options);
      rzp.open();
    });
  },
};
